exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jlam2/impresocloud/www/client/src/app/layouts/public-layout.component.scss
// module id = ../../../../../src/app/layouts/public-layout.component.scss
// module chunks = main